import { Trans, useTranslation } from "react-i18next";

import { Logo } from "@/components/Logo";
import { cn } from "@/lib/utils";

interface IAuthHeaderProps {
  className?: string;
  description: string;
}

export const AuthHeader = ({ className, description }: IAuthHeaderProps) => {
  const { t } = useTranslation("auth");

  return (
    <div className={cn("flex flex-col justify-center", className)}>
      <Logo
        wrapperClassName="self-center"
        className="h-logo-height-auth w-auto"
      />
      <h1
        className="text-xl md:text-2xl lg:text-3xl text-center mt-3 md:mt-5 lg:mt-7 font-semibold"
        data-testid="auth-header_title"
      >
        <Trans
          t={t}
          i18nKey="title"
          components={{
            Highlighted: <span className="text-highlighted" />,
          }}
        />
      </h1>
      <p
        className="text-center text-foreground-secondary mt-2 md:mt-3 lg:mt-4"
        data-testid="auth-header_description"
      >
        {description}
      </p>
    </div>
  );
};
